export class HanyoListViewModel {
    constructor(model = []) {
        this.model = model;
    }
    model = [];
    GetByHanyoKb(hanyoKb) {
        return this.model.find(x => x.hanyoKb === Number(hanyoKb))?.hanyoList ?? [];
    }
}
